
define('inlineSvg!svgs/icon/reply', function () {return '<span class="inline-reply inline-icon"><svg width="18" height="18"><path d="M10.1 5l.9-1 4 4.5v1L11 14l-.9-1 2.5-3H4L3 9V6.5h2V8h7.6l-2.5-3z"/></svg></span>';});

